export interface Level {
  value: string;
  unit: string;
}

export const parseChargingTime = (timeString: string): Level | null => {
  if (timeString === 'N/A') return null;
  const parts = timeString.trim().split(' ');
  const value = Math.round(Number(parts[0])).toLocaleString();
  const unit = parts.pop() || '';
  return { value, unit };
};
